export const TOKEN = 'jwt_access_token';
export const USER_ROLE = 'user_role';
